<template>
  <div class="wx-open-message-configure">
    <el-tabs tab-position="top">
      <el-tab-pane label="类目模板"
                   lazy>
        <WxOpenMessageConfigurePub></WxOpenMessageConfigurePub>
      </el-tab-pane>
      <el-tab-pane label="个人模板"
                   lazy>
        <WxOpenMessageConfigureTpl></WxOpenMessageConfigureTpl>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import WxOpenMessageConfigurePub from './pub'
import WxOpenMessageConfigureTpl from './tpl'
export default {
  name: 'WxOpenMessageConfigure',
  components: {
    WxOpenMessageConfigurePub,
    WxOpenMessageConfigureTpl
  }
}
</script>

<style lang="scss">
  .wx-open-message-configure {
    height: 560px;
    .el-tabs {
      &.el-tabs--top {
        position: relative;
        height: 100%;
        & > .el-tabs__header {
          margin-bottom: 0;
          padding: 0 15px;
          box-sizing: border-box;
          & > .el-tabs__nav-wrap {
            & > .el-tabs__nav-scroll {
              & > .el-tabs__nav {
                & > .el-tabs__item {
                  min-width: 92px;
                  height: 36px;
                  font-size: 13px;
                  text-align: center;
                  line-height: 36px;
                }
              }
            }
          }
        }
        & > .el-tabs__content {
          position: absolute;
          left: 0;
          top: 36px;
          right: 0;
          bottom: 0;
          & > .el-tab-pane {
            height: 100%;
          }
        }
      }
    }
  }
</style>
